import styled from "styled-components";

import { Flex } from "@similarweb/ui-components/foundations";

export const StyledGradAccessWrapper = styled(Flex)`
    margin: 10px 0;
`;
